import { FieldValues } from 'react-hook-form';

export const filterEmptyFields = (obj: FieldValues) => {
  if (!obj) {
    return null;
  }

  const keys = Object.keys(obj);
  if (keys.length === 0) {
    return null;
  }

  return keys.reduce<FieldValues>((all, key) => {
    if (typeof obj[key] === 'object') {
      const cleanedObject = filterEmptyFields(obj[key]);
      if (cleanedObject && Object.keys(cleanedObject)?.length > 0) {
        all[key] = cleanedObject;
      }
    } else if (obj[key] !== '') {
      all[key] = obj[key];
    }
    return all;
  }, {});
};
